import React from 'react';
import Dialog from 'Components/Core/Dialog';
import './PollHintDialog.css';

// Modaler Hint-Dialog fuer offene, unbeantwortete Umfragen. Erscheint einmal
// pro Forumsbesuch (Aufruf von load() aus Content.js beim Login), zwingt zu
// einer echten Entscheidung ("Abstimmen"/"Nicht teilnehmen"), laesst sich
// aber per Escape/Backdrop-Klick vertagen: dann passiert nichts, die Umfrage
// erscheint beim naechsten Besuch (naechster load()-Aufruf) wieder, da weder
// pollVote noch pollDismissal geschrieben wurde.
export default function PollHintDialog(props) {

	const x = props.x;
	const [queue, setQueue] = React.useState([]);
	const [selected, setSelected] = React.useState([]);

	x.wad.init(props.id);

	x.was.loadPendingPolls = load;

	function load() {
		x.was.axGet('Backend/webapp.php?module=Poll&task=GetPendingPolls', (result) => {
			if (result.data.returncode === 1 && result.data.content.length > 0) {
				setQueue(result.data.content);
				setSelected([]);
				x.wad[props.id].show();
			}
		});
	}

	function advance() {
		setQueue((current) => current.slice(1));
		setSelected([]);
	}

	function toggleOption(poll, optionId) {
		setSelected((current) => {
			if (poll.ismultiplechoice) {
				return current.includes(optionId)
					? current.filter((id) => id !== optionId)
					: [...current, optionId];
			}
			return [optionId];
		});
	}

	function vote(poll) {
		if (selected.length === 0) return;
		x.was.axPost('Backend/webapp.php?module=Poll&task=Vote', { optionIds: selected }, (result) => {
			if (result.data.returncode === 1) {
				closeCurrentOrAdvance();
			}
			else {
				x.wah.addHint('Abstimmen fehlgeschlagen.', true);
			}
		});
	}

	function dismiss(poll) {
		x.was.axPost('Backend/webapp.php?module=Poll&task=DismissPoll', { pollId: poll.pollid }, (result) => {
			if (result.data.returncode === 1) {
				closeCurrentOrAdvance();
			}
		});
	}

	function closeCurrentOrAdvance() {
		if (queue.length <= 1) {
			x.wad[props.id].hide();
		}
		advance();
	}

	if (queue.length === 0) {
		return <Dialog id={props.id} x={x} display="d-none" classes="dialog-poll-hint" title="Umfrage" modal={true} />;
	}

	const poll = queue[0];

	return (
		<Dialog id={props.id} x={x} display="d-none" classes="dialog-poll-hint" title="Umfrage" modal={true}>
			<div className="poll-hint-question">{poll.question}</div>
			<div className="poll-hint-options">
				{poll.options.map((option) => (
					<label key={option.optionid} className="poll-hint-option">
						<input
							type={poll.ismultiplechoice ? 'checkbox' : 'radio'}
							name={'poll-hint-' + poll.pollid}
							checked={selected.includes(option.optionid)}
							onChange={() => toggleOption(poll, option.optionid)}
						/>
						<span>{option.optiontext}</span>
					</label>
				))}
			</div>
			<div className="poll-hint-buttons">
				<button className="btn" type="button" onClick={() => vote(poll)} disabled={selected.length === 0}>
					Abstimmen
				</button>
				<button className="btn" type="button" onClick={() => dismiss(poll)}>
					Nicht teilnehmen
				</button>
			</div>
		</Dialog>
	)

};
